// src/plugins/vuetify/theme.js

import colors from 'vuetify/lib/util/colors'

export default {
  primary: {
    base: colors.green.darken2,
    darken1: colors.green.darken3,
  },
  secondary: colors.brown.base,
  // All keys will generate theme styles,
  // Here we add a custom `tertiary` color
  tertiary: colors.red.base,
}
